/** `GET /v1/me/purchase-faults` — the customer's open product faults (D-19), for the dashboard banner. */
import { API_BASE } from '@/src/infrastructure/lib/api';
import { auth } from '@/src/infrastructure/config/firebase';

export interface PurchaseFault {
  purchaseId: string;
  invitationId: string | null;
  eventName: string | null;
  invitationStatus: string | null;
  source: 'SYSTEM' | 'ADMIN';
  flaggedAt: string;
  deadline: string;
  supportTicketId: string | null;
}

export async function listPurchaseFaults(): Promise<PurchaseFault[]> {
  const token = await auth.currentUser?.getIdToken().catch(() => null);
  const res = await fetch(`${API_BASE}/me/purchase-faults`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = await res.json();
  return ((body?.data !== undefined ? body.data : body)?.items ?? []) as PurchaseFault[];
}
